function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'pink': 'rgb(237, 37, 144)','beige': 'rgb(181, 170, 168)','smoke': 'rgb(174, 158, 158)','gold': 'rgb(218, 193, 161)','silver': 'rgb(187, 180, 170)','gun': 'rgb(103, 98, 95)',};

    this.images = {'tortoise': 'url("//www.thinoptics.com/cdn/shop/files/tortoise_68x.png?v=13624894856519981387")','black-grey': 'url("//www.thinoptics.com/cdn/shop/files/black-grey_68x.png?v=7375294404642630660")','tortoise-brown': 'url("//www.thinoptics.com/cdn/shop/files/tortoise-brown_68x.png?v=13218035971070258634")','tortoise-green': 'url("//www.thinoptics.com/cdn/shop/files/tortoise-green_68x.png?v=1193986089663503588")','black-green': 'url("//www.thinoptics.com/cdn/shop/files/black-green_68x.png?v=12432311322667615948")','crystal-blue': 'url("//www.thinoptics.com/cdn/shop/files/crystal-blue_68x.png?v=13157739500712320466")','crystal-grey': 'url("//www.thinoptics.com/cdn/shop/files/crystal-grey_68x.png?v=12337035376899173136")','black-silver': 'url("//www.thinoptics.com/cdn/shop/files/black-silver_68x.png?v=6655287223303860363")','gold-green': 'url("//www.thinoptics.com/cdn/shop/files/gold-green_68x.png?v=5936505328900801806")','gold-brown': 'url("//www.thinoptics.com/cdn/shop/files/gold-brown_68x.png?v=12855977385717227721")','gunmetal-grey': 'url("//www.thinoptics.com/cdn/shop/files/gunmetal-grey_68x.png?v=9468951099388086777")','5-pack': 'url("//www.thinoptics.com/cdn/shop/files/5-pack_68x.png?v=7007772062676069826")','blossoming-green': 'url("//www.thinoptics.com/cdn/shop/files/blossoming-green_68x.png?v=160223529246262339")','sunrise-orange': 'url("//www.thinoptics.com/cdn/shop/files/sunrise-orange_68x.png?v=2819408314380149800")','daffodil-yellow': 'url("//www.thinoptics.com/cdn/shop/files/daffodil-yellow_68x.png?v=3627977886815071192")','blushing-pink': 'url("//www.thinoptics.com/cdn/shop/files/blushing-pink_68x.png?v=15724346192172587553")','ocean-mist-teal': 'url("//www.thinoptics.com/cdn/shop/files/ocean-mist-teal_68x.png?v=413422833448738742")','black-matte': 'url("//www.thinoptics.com/cdn/shop/files/matt-black_68x.jpg?v=10606760181643543046")','black-glossy': 'url("//www.thinoptics.com/cdn/shop/files/glossy-black_68x.jpg?v=16433593066680082255")','red-matte': 'url("//www.thinoptics.com/cdn/shop/files/matt-red_68x.jpg?v=1384798201665165652")','red-glossy': 'url("//www.thinoptics.com/cdn/shop/files/glossy-red_68x.jpg?v=12534340514288444565")','blue-matte': 'url("//www.thinoptics.com/cdn/shop/files/matt-blue_68x.jpg?v=11098817163580481775")','blue-glossy': 'url("//www.thinoptics.com/cdn/shop/files/glossy-blue_68x.png?v=6664796096170485995")','tortoise-matte': 'url("//www.thinoptics.com/cdn/shop/files/tortoise_68x.png?v=13624894856519981387")','tortoise-glossy': 'url("//www.thinoptics.com/cdn/shop/files/tortoise_68x.png?v=13624894856519981387")','multi-color': 'url("//www.thinoptics.com/cdn/shop/files/multi-color_68x.png?v=201462952881225263")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
